import { createActions } from '~/store/utils';

const { Types, Actions } = createActions({
  FORGOT_PASSWORD_REQUEST: null,
  FORGOT_PASSWORD_SUCCESS: null,
  FORGOT_PASSWORD_ERROR: null,
  FORGOT_PASSWORD_RESET: null,

  PASSWORD_RULES_REQUEST: null,
  PASSWORD_RULES_SUCCESS: null,
  PASSWORD_RULES_FAILURE: null,
  PASSWORD_RULES_ERROR: null,

  RESET_PASSWORD_REQUEST: null,
  RESET_PASSWORD_SUCCESS: null,
  RESET_PASSWORD_FAILURE: null,
  RESET_PASSWORD_ERROR: null,

  SET_RESET_TOKEN: null,
});

export { Actions, Types };
